import {
  Box,
  CircularProgress,
  Divider,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import CustomButton from '../../components/mui/CustomButton';
import { useEffect, useState } from 'react';
import InputField1 from '../../components/mui/InputField1';
import DropDownMenu from '../../components/mui/DropDownMenu';
import { useDispatch } from 'react-redux';
import { enqueueSnackbar } from 'notistack';
import { uploadDocument } from '../../actions/clientsAuth';
import RModal from '../../components/mui/RModal';
import { getAllTransactions } from '../../actions/transactionsAuth';
import { useParams } from 'react-router-dom';

export const Transactions = ({ data = [] }) => {
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [loadingTransactions, setLoadingTransactions] = useState(true);
  const [expandedTransactionId, setExpandedTransactionId] = useState(null);
  const [formData, setFormData] = useState({
    balance: '',
    rechargeAction: '',
    transactionId: '',
    transactionDate: '',
    remark: '',
    paymentMode: '',
    referenceDocument: null,
  });

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    console.log(formData);

   
    setTimeout(() => {
      setLoading(false);
      handleClose();
    }, 2000);
  };

  const [fileUrl, setFileUrl] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    let isMounted = true;

    const getTransactions = () => {
      setLoadingTransactions(true);
      dispatch(
        getAllTransactions(
          { page: 0, size: 1000, userId: id, businessAccountId: id },
          (response) => {
            if (!isMounted) return;
            const transactionsList =
              response?.content ||
              response?.data?.content ||
              response?.data?.data?.content ||
              response?.data?.data?.Transactions ||
              response?.data?.Transactions ||
              response?.data?.data ||
              response?.data ||
              data ||
              [];

            const normalizedList = Array.isArray(transactionsList)
              ? transactionsList
              : [];

            const filteredTransactions = normalizedList.filter((item) => {
              const transactionUserId = item?.transaction?.userId || item?.userId;
              const userId = item?.user?.id || item?.user?._id;
              const businessAccountId =
                item?.businessAccountId || item?.user?.businessAccountId;
              const orderUserId = item?.orders?.[0]?.userId;

              return (
                !id ||
                transactionUserId === id ||
                userId === id ||
                orderUserId === id ||
                businessAccountId === id
              );
            });

            setTransactions(
              filteredTransactions.length > 0
                ? filteredTransactions
                : normalizedList
            );
            setLoadingTransactions(false);
          },
          () => {
            if (!isMounted) return;
            setTransactions(Array.isArray(data) ? data : []);
            setLoadingTransactions(false);
          }
        )
      );
    };

    getTransactions();

    return () => {
      isMounted = false;
    };
  }, [dispatch, id, data]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      addressProofDocument: file,
    });

    handleFileUpload(file);
  };

  const formatValue = (value) => {
    if (value === null || value === undefined || value === '') return 'N/A';
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    return value;
  };

  const formatDateTime = (value) => {
    if (!value) return 'N/A';
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return value;
    return parsed.toLocaleString();
  };

  const InfoItem = ({ label, value }) => (
    <Grid item xs={12} md={6}>
      <Typography variant='body2' color='text.secondary'>
        {label}
      </Typography>
      <Typography variant='body1'>{formatValue(value)}</Typography>
    </Grid>
  );

  const toggleOrderDetails = (transactionKey) => {
    setExpandedTransactionId((prev) =>
      prev === transactionKey ? null : transactionKey
    );
  };
  const handleFileUpload = (file) => {
    if (file) {
      const formData = new FormData();
      formData.append('file', file);

      dispatch(
        uploadDocument(
          formData,
          (response) => {
            console.log(
              'File uploaded successfully:',
              response.data
            );
            setFileUrl(response.data);
            enqueueSnackbar('File uploaded successfully.', {
              variant: 'success',
            });
          },
          (error) => {
            console.error('Error uploading file:', error);
            enqueueSnackbar('Error uploading file.', {
              variant: 'error',
            });
          }
        )
      );
    }
  };

  return (
    <>
      <Stack alignItems='center' direction={'row'} mt={1}>
        <Typography
          variant='h4'
          my={1}
          flexGrow={1}
          fontSize={{ xl: '22px', sm: '1rem', xs: '1rem' }}
        ></Typography>

        {/* <CustomButton
          variant='contained'
          onClick={handleOpen}
          fontSize={{ xl: '1rem', sm: '.7rem', xs: '.7rem' }}
        >
          <Add sx={{ mr: { xl: 1, sm: 0.2 } }} />
          Recharge Wallet
        </CustomButton> */}
      </Stack>
      <RModal
        open={open}
        handleClose={handleClose}
        width={{ md: '60%', xs: '80%' }}
        height={{ md: '80%', xs: '80%' }}
      >
        <Box>
          <Typography
            id='modal-title'
            variant='h6'
            component='h2'
          >
            Recharge Wallet
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={0.5}>
              <Grid item md={6} xs={12}>
                <InputField1
                  placeholderColor='#8D98AA'
                  label='⁠Action'
                  placeholder='Enter ⁠Action'
                  spanP={true}
                  required
                  maxLength={20}
                  name='rechargeAction'
                  value={formData.rechargeAction}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <InputField1
                  placeholderColor='#8D98AA'
                  label='Balance'
                  placeholder='Enter Balance'
                  spanP={true}
                  required
                  maxLength={20}
                  name='balance'
                  value={formData.balance}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <InputField1
                  placeholderColor='#8D98AA'
                  label='Transaction Id'
                  placeholder='Enter Transaction Id'
                  spanP={true}
                  required
                  maxLength={20}
                  name='transactionId'
                  value={formData.transactionId}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Typography variant='h6' pt={2} pb={1}>
                  Payment Mode
                </Typography>
                <DropDownMenu
                  buttonText={
                    formData.paymentMode || 'Select Payment Mode'
                  }
                  menuItems={[
                    { label: 'Imps/Rtgs/NEFT' },
                    { label: 'UPI' },
                    { label: 'Virtual Account' },
                    { label: 'OffLine Mode' },
                  ]}
                  selectedItem={formData.paymentMode}
                  setSelectedItem={(item) =>
                    setFormData({
                      ...formData,
                      paymentMode: item.label,
                    })
                  }
                  buttonWidth='100%'
                  name='paymentMode'
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <InputField1
                  placeholderColor='#8D98AA'
                  label='Transaction Date'
                  spanP={true}
                  name='transactionDate'
                  value={formData.transactionDate}
                  onChange={handleChange}
                  type={'date'}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Typography
                  variant='h6'
                  component={'p'}
                  mt={2}
                  mb={1}
                >
                  Upload Proof Document
                </Typography>
                <TextField
                  fileUpload={true}
                  onChange={handleFileChange}
                  py={'10px'}
                  type={'file'}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant='h6' my={1}>
                  Remark
                </Typography>
                <TextField
                  multiline
                  fullWidth
                  placeholder='Enter remark here ......'
                  name='remark'
                  value={formData.remark}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
            <Box mt={3} textAlign='right'>
              <CustomButton
                variant='contained'
                width='10rem'
                color='primary'
                type='submit'
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Recharge Wallet'}
              </CustomButton>
            </Box>
          </form>
        </Box>
      </RModal>
      <Box mt={2}>
        {loadingTransactions ? (
          <Stack alignItems='center' py={4}>
            <CircularProgress size={28} />
          </Stack>
        ) : transactions.length === 0 ? (
          <Typography textAlign='center' py={3}>
            No transactions found
          </Typography>
        ) : (
          transactions.map((item, index) => {
            const transactionData =
              item?.transaction && typeof item.transaction === 'object'
                ? item.transaction
                : item;
            const transactionKey =
              transactionData?.id || item?.id || `transaction-${index}`;
            const userData = item?.user || {};
            const orders = Array.isArray(item?.orders) ? item.orders : [];
            const primaryOrder = orders[0] || {};
            const isExpanded = expandedTransactionId === transactionKey;

            const displayUser = {
              id: userData?.id || userData?._id || item?.userId,
              name: userData?.name || item?.userName,
              email: userData?.email || item?.userEmail,
              phone: userData?.phone || item?.userPhone,
              role: userData?.role || item?.userRole,
              username: userData?.username || item?.username,
              active:
                userData?.active !== undefined ? userData.active : item?.userActive,
              deleted:
                userData?.deleted !== undefined
                  ? userData.deleted
                  : item?.userDeleted,
            };

            return (
              <Paper
                key={transactionKey}
                elevation={2}
                sx={{ p: 2, mb: 2 }}
              >
                <Box
                  display='flex'
                  justifyContent='space-between'
                  alignItems='center'
                  sx={{ cursor: 'pointer' }}
                  onClick={() => toggleOrderDetails(transactionKey)}
                >
                  <Typography variant='h5' mb={2}>
                    Transaction {index + 1}
                  </Typography>
                  <Typography variant='body2' color='primary'>
                    {isExpanded ? 'Hide Order Details' : 'View Order Details'}
                  </Typography>
                </Box>

                <Typography variant='h6' mb={1}>
                  Transaction Details
                </Typography>
                <Grid container spacing={1.5}>
                  <InfoItem label='Transaction ID' value={transactionData?.id} />
                  <InfoItem label='Order ID' value={transactionData?.orderId} />
                  <InfoItem label='Amount' value={transactionData?.amount} />
                  <InfoItem label='Entry Type' value={transactionData?.entryType} />
                  <InfoItem label='Status' value={transactionData?.status} />
                  <InfoItem
                    label='Payment Type'
                    value={transactionData?.paymentType}
                  />
                  <InfoItem
                    label='Razorpay Order ID'
                    value={transactionData?.razorpayOrderId}
                  />
                  <InfoItem
                    label='Razorpay Payment ID'
                    value={transactionData?.razorpayPaymentId}
                  />
                  <InfoItem
                    label='Created At'
                    value={formatDateTime(transactionData?.createdAt)}
                  />
                  <InfoItem
                    label='Updated At'
                    value={formatDateTime(transactionData?.updatedAt)}
                  />
                </Grid>

                <Divider sx={{ my: 1 }} />

                <Typography variant='h6' mb={1}>
                  User Details
                </Typography>
                <Grid container spacing={1.5}>
                  <InfoItem label='User ID' value={displayUser?.id} />
                  <InfoItem label='Name' value={displayUser?.name} />
                  <InfoItem label='Email' value={displayUser?.email} />
                  <InfoItem label='Phone' value={displayUser?.phone} />
                  <InfoItem label='Role' value={displayUser?.role} />
                  <InfoItem label='Username' value={displayUser?.username} />
                  <InfoItem label='Active' value={displayUser?.active} />
                  <InfoItem label='Deleted' value={displayUser?.deleted} />
                </Grid>

                {isExpanded && (
                  <>
                    <Divider sx={{ my: 1 }} />
                    <Box>
                      <Typography variant='h6' mb={1}>
                        Order Details
                      </Typography>
                      {!primaryOrder?.id ? (
                        <Typography variant='body2'>No order data available</Typography>
                      ) : (
                        <>
                          <Grid container spacing={1.5} mb={1}>
                            <InfoItem label='Order ID' value={primaryOrder?.id} />
                            <InfoItem
                              label='Transaction ID'
                              value={primaryOrder?.transactionId}
                            />
                            <InfoItem label='Currency' value={primaryOrder?.currency} />
                            <InfoItem
                              label='Denomination'
                              value={primaryOrder?.denomination}
                            />
                            <InfoItem
                              label='Total Amount'
                              value={primaryOrder?.totalAmount}
                            />
                            <InfoItem
                              label='Payment Mode'
                              value={primaryOrder?.paymentMode}
                            />
                            <InfoItem
                              label='Payment Status'
                              value={primaryOrder?.paymentStatus}
                            />
                            <InfoItem
                              label='Product Code'
                              value={primaryOrder?.productCode}
                            />
                            <InfoItem
                              label='Created At'
                              value={formatDateTime(primaryOrder?.createdAt)}
                            />
                          </Grid>

                          {Array.isArray(primaryOrder?.lines) &&
                            primaryOrder.lines.length > 0 && (
                              <Box mt={1}>
                                <Typography variant='subtitle2' mb={1}>
                                  Order Lines
                                </Typography>
                                {primaryOrder.lines.map((line, lineIndex) => (
                                  <Box
                                    key={`${primaryOrder?.id}-line-${lineIndex}`}
                                    sx={{
                                      mb: 1,
                                      p: 1,
                                      background: '#fafafa',
                                      borderRadius: 1,
                                    }}
                                  >
                                    <Grid container spacing={1.5}>
                                      <InfoItem
                                        label='Brand Product Code'
                                        value={line?.brandProductCode}
                                      />
                                      <InfoItem
                                        label='Brand ID'
                                        value={line?.brandId}
                                      />
                                      <InfoItem
                                        label='Quantity'
                                        value={line?.quantity}
                                      />
                                      <InfoItem
                                        label='Unit Price'
                                        value={line?.unitPrice}
                                      />
                                      <InfoItem
                                        label='Line Total'
                                        value={line?.lineTotal}
                                      />
                                      <InfoItem
                                        label='Denomination'
                                        value={line?.denomination}
                                      />
                                    </Grid>
                                  </Box>
                                ))}
                              </Box>
                            )}
                        </>
                      )}
                      {orders.length > 1 &&
                        orders.slice(1).map((order, orderIndex) => (
                          <Box
                            key={order?.id || `order-${orderIndex + 1}`}
                            sx={{
                              mt: 1,
                              p: 1.5,
                              border: '1px solid #e0e0e0',
                              borderRadius: 1,
                            }}
                          >
                            <Typography variant='subtitle2' mb={1}>
                              Additional Order {orderIndex + 2}:{' '}
                              {formatValue(order?.id)}
                            </Typography>
                            <Typography variant='body2' color='text.secondary'>
                              Payment: {formatValue(order?.paymentMode)} | Status:{' '}
                              {formatValue(order?.paymentStatus)} | Amount:{' '}
                              {formatValue(order?.totalAmount)}
                            </Typography>
                          </Box>
                        ))}
                    </Box>
                  </>
                )}
              </Paper>
            );
          })
        )}
      </Box>
    </>
  );
};
